import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * A small uppercase section heading used throughout the UI Kit documentation
 * and detail pages. Renders as an `<h3>` with consistent sizing and muted color.
 *
 * @example
 * <app-section-heading>Solid (default)</app-section-heading>
 */
@Component({
  selector: 'app-section-heading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `<p role="heading" aria-level="3" class="text-xs font-semibold uppercase tracking-wide text-muted mb-4" style="font-family: var(--font-body)"><ng-content></ng-content></p>`,
})
export class SectionHeadingComponent {}
